import * as dbVisibleFieldsService from 'serviceWorker/db/visibleFields/visibleFieldsService';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { debugLog } from 'shared/logger/debugLog';
import { VisibleFieldModel } from 'shared/domain/visibleField/visibleFieldModel';
import { getAllCurrentVisibleFieldsPromise } from 'serviceWorker/services/visibleFields/getVisibleFieldsPromise';
import { visibleFieldContract } from 'shared/domain/visibleField/visibleFieldContract';
import { makeErrorPublisher, makeEventPublisher, makeLoadedEventPublisher, readCollectionPayload } from 'serviceWorker/broadcasts/publishers';

export const broadcastAllVisibleFields = makeLoadedEventPublisher(
  visibleFieldContract,
  DomainMessagesTypes.allVisibleFields,
  () => readCollectionPayload(dbVisibleFieldsService, getAllCurrentVisibleFieldsPromise)
);

const broadcastVisibleFieldError = makeErrorPublisher(
  visibleFieldContract
);

export const broadcastUploadedVisibleFieldError = (
  error: unknown,
  messageId?: string | null,
  uniqueId?: string
): void => {
  debugLog('broadcastUploadedVisibleFieldError', error, messageId, uniqueId);
  broadcastVisibleFieldError(DomainMessagesTypes.failUploadedEntity, error, {
    messageId: messageId || undefined,
    uniqueId,
  });
};

export const broadcastUploadedVisibleField = makeEventPublisher(visibleFieldContract, DomainMessagesTypes.uploadedEntity);
